import { put, takeLatest } from 'redux-saga/effects';
import { SaveLicense } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// utils
import format from 'date-fns/format';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { new_license } }) {
    try {

        const token = yield authService.getAccessToken();
        
        const response = yield fetch('/Licenses/SaveLicense/'
            + new_license.pk + '/'
            + new_license.sn + '/'
            + new_license.tipologia + '/'
            + (new_license.data_scadenza === null ? null : format(new_license.data_scadenza, 'yyyy-MM-dd')) + '/'
            + (new_license.cliente === '' ? null : new_license.cliente) + '/'
            + (new_license.email === '' ? null : new_license.email) + '/'
            + new_license.codice_utente + '/'
            + new_license.multiazienda + '/'
            + (new_license.codice_azienda === '' ? null : new_license.codice_azienda), {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });

        let responseResult = '';

        responseResult = yield response.text();

        if (responseResult === Message.Inserted) {
            yield put(SaveLicense.creators.saveLicenseSuccess({ isInserted: responseResult }));
        }
        else if (responseResult === Message.NotInserted) {
            yield put(SaveLicense.creators.saveLicenseFailed(responseResult));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(SaveLicense.creators.saveLicenseFailed(responseResult.substring(5)));
        }
        else yield put(SaveLicense.creators.saveLicenseFailed(responseResult));

    } catch (e) {
        yield put(SaveLicense.creators.saveLicenseFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(SaveLicense.types.SAVE_LICENSE_REQUEST, runAction);
}